var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
var ButtonBox = function (_a) {
    var onBackButtonClick = _a.onBackButtonClick, onForwardButtonClick = _a.onForwardButtonClick;
    return (_jsxs(Container, { children: [_jsx(ButtonWrapper, __assign({ type: "button", onClick: onBackButtonClick, "aria-label": "backButton" }, { children: _jsx(IoIosArrowBack, { size: "60%", color: "#646262" }) })), _jsx(ButtonWrapper, __assign({ type: "button", onClick: onForwardButtonClick, "aria-label": "forwardButton" }, { children: _jsx(IoIosArrowForward, { size: "60%", color: "#646262" }) }))] }));
};
export default React.memo(ButtonBox);
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  top: 45%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 0rem 1rem;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  top: 45%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 0rem 1rem;\n"])));
var ButtonWrapper = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 3rem;\n  height: 3rem;\n  border: 0;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 4rem;\n  background: #ffffff8c;\n  cursor: pointer;\n"], ["\n  width: 3rem;\n  height: 3rem;\n  border: 0;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 4rem;\n  background: #ffffff8c;\n  cursor: pointer;\n"])));
var templateObject_1, templateObject_2;
